import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useCreateUser } from "@/hooks/use-users";
import { toast } from "sonner";

export function CreateUserPage() {
  const navigate = useNavigate();
  const createUser = useCreateUser();
  const [uid, setUid] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!uid.trim() || !password) {
      toast.error("Username and password are required.");
      return;
    }

    try {
      await createUser.mutateAsync({ uid: uid.trim(), password });
      toast.success(`User ${uid.trim()} created`);
      navigate("/");
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to create user");
    }
  };

  return (
    <div className="mx-auto max-w-md space-y-6">
      <Button variant="ghost" size="sm" asChild className="-ml-3">
        <Link to="/">
          <ArrowLeft className="mr-2 h-4 w-4" /> Back to users
        </Link>
      </Button>

      <Card>
        <CardHeader className="space-y-1">
          <CardTitle className="text-xl">Create user</CardTitle>
          <CardDescription>Add a new VPN user to OpenLDAP.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="uid">Username</Label>
              <Input
                id="uid"
                value={uid}
                onChange={(e) => setUid(e.target.value)}
                placeholder="johndoe"
                className="h-11"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="h-11"
              />
            </div>
            <Button type="submit" className="w-full h-11" disabled={createUser.isPending}>
              {createUser.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Create user
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
